<!-- Enhanced Hero Section -->
<section class="hero" id="home">
  <div class="hero-overlay"></div>

  <div class="container hero-layout">
    <!-- Hero Content (Left) -->
    <div class="hero-content">
      <div class="hero-logo-container fade-in">
        <img [src]="logoPath" [alt]="hotelName + ' Logo'" class="hero-logo-image">
      </div>
      <h1 class="hero-title slide-in-up">{{ hotelName }}</h1>
      <p class="hero-subtitle slide-in-up delay-1">
        Un refugio de tradición andina en el corazón de Sarhua
      </p>
      <p class="hero-description slide-in-up delay-2 body-2">
        Descubre la perfecta armonía entre la cultura ancestral y el confort moderno
      </p>
      <div class="hero-actions slide-in-up delay-3">
        <button class="btn btn-primary btn-lg" (click)="scrollToSection('habitaciones')">
          Ver Habitaciones
        </button>
        <button class="btn btn-outline-light btn-lg" (click)="scrollToSection('contacto')">
          Contactar
        </button>
      </div>
    </div>

    <!-- Floating Booking Widget (Right) -->
    <div class="floating-booking-widget glass">
      <h3 class="booking-widget-title">Reserva tu Habitación</h3>
      <form class="booking-widget-form" (ngSubmit)="checkAvailability()">
        <div class="booking-fields-row">
          <div class="booking-field">
            <label class="booking-label">
              <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" />
                <path d="M3 10H21" stroke="currentColor" stroke-width="1.5" />
                <path d="M8 2V6M16 2V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              Check In
            </label>
            <input type="date" class="booking-input" [(ngModel)]="checkInDate" (change)="onCheckInChange()"
              [min]="getMinDate()" name="checkIn" required>
          </div>
          <div class="booking-field">
            <label class="booking-label">
              <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" />
                <path d="M3 10H21" stroke="currentColor" stroke-width="1.5" />
                <path d="M8 2V6M16 2V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              Check Out
            </label>
            <input type="date" class="booking-input" [(ngModel)]="checkOutDate" [min]="getMinCheckoutDate()"
              name="checkOut" required>
          </div>
          <div class="booking-field booking-field-guests">
            <label class="booking-label">
              <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                <circle cx="9" cy="7" r="3" stroke="currentColor" stroke-width="1.5" />
                <circle cx="15" cy="7" r="3" stroke="currentColor" stroke-width="1.5" />
                <path d="M3 21V19C3 16.79 6.58 15 12 15C17.42 15 21 16.79 21 19V21" stroke="currentColor"
                  stroke-width="1.5" />
              </svg>
              Huéspedes
            </label>
            <select class="booking-input" [(ngModel)]="selectedGuests" (change)="onGuestsChange()" name="guests"
              required>
              <option *ngFor="let option of guestOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
          <div class="booking-field booking-field-room">
            <label class="booking-label">
              <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                <path d="M3 18V12C3 10.9 3.9 10 5 10H19C20.1 10 21 10.9 21 12V18" stroke="currentColor"
                  stroke-width="1.5" />
                <path d="M3 18H21V20C21 21.1 20.1 22 19 22H5C3.9 22 3 21.1 3 20V18Z" stroke="currentColor"
                  stroke-width="1.5" />
                <path d="M7 10V8C7 5.24 9.24 3 12 3C14.76 3 17 5.24 17 8V10" stroke="currentColor" stroke-width="1.5" />
              </svg>
              Tipo de Habitación
            </label>
            <select class="booking-input" [(ngModel)]="selectedRoomType" name="roomType" required
              [class.no-options]="!hasAvailableRooms()">
              <option *ngIf="!hasAvailableRooms()" value="" disabled>
                No hay habitaciones para {{ selectedGuests }} huéspedes
              </option>
              <option *ngFor="let room of filteredRoomTypes" [value]="room.id">
                {{ room.name }} ({{ room.capacidad }} pers.){{ room.priceMin > 0 ? ' - S/. ' + room.priceMin : '' }}
                {{ room.priceMax > 0 ? ' - S/. ' + room.priceMax : '' }}
              </option>
            </select>
            <span class="booking-hint" *ngIf="hasAvailableRooms()">
              {{ filteredRoomTypes.length }} opción{{ filteredRoomTypes.length !== 1 ? 'es' : '' }} disponible{{
              filteredRoomTypes.length !== 1 ? 's' : '' }}
            </span>
            <span class="booking-hint booking-hint-warning" *ngIf="!hasAvailableRooms()">
              Reduce el número de huéspedes o reserva múltiples habitaciones
            </span>
          </div>
          <button type="submit" class="btn-booking-search">
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
              <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
              <path d="M21 21L16 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            VERIFICAR DISPONIBILIDAD
          </button>
        </div>
        <!-- Precio estimado -->
        <div class="booking-price-preview" *ngIf="calculateEstimatedPriceMin() > 0">
          <span class="price-label">Precio estimado:</span>
          <span *ngIf="calculateEstimatedPriceMin() === calculateEstimatedPriceMax()">
            <span class="price-value">S/. {{ calculateEstimatedPriceMin() | number : '1.2-2' }}</span>
          </span>
          <span *ngIf="calculateEstimatedPriceMin() !== calculateEstimatedPriceMax()">
            <span class="price-value">S/. {{ calculateEstimatedPriceMin() | number : '1.2-2' }} - S/. {{
              calculateEstimatedPriceMax() | number : '1.2-2'
              }}</span>
          </span>
        </div>
      </form>
    </div>
  </div>

  <div class="scroll-indicator">
    <span class="scroll-text body-4">Descubre más</span>
    <div class="scroll-arrow">↓</div>
  </div>
</section>

<!-- About Section -->
<section class="about section" id="sobre-nosotros">
  <div class="container">
    <div class="section-header text-center fade-in-scroll">
      <span class="section-subtitle">Conoce Nuestra Historia</span>
      <h2>{{ hotelName }}</h2>
      <div class="section-divider"></div>
    </div>

    <div class="about-grid">
      <div class="about-content fade-in-scroll">
        <p class="body-2">
          En el pintoresco pueblo de Sarhua, donde las montañas andinas abrazan el cielo
          y la cultura ancestral se entrelaza con la modernidad, te damos la bienvenida a
          <strong>SUNTUR QURI WASI</strong>.
        </p>
        <p class="body-2">
          Nuestro nombre, que en quechua significa "Casa del Sol Dorado", refleja nuestra
          esencia: un lugar donde la calidez del sol andino se combina con la hospitalidad
          más genuina para ofrecerte una experiencia única.
        </p>
        <p class="body-2">
          Cada rincón de nuestro hotel ha sido diseñado para honrar la rica herencia cultural
          de Sarhua, famosa por sus tablas pintadas y su tradición artística, mientras te
          brindamos todas las comodidades del confort moderno.
        </p>
        <button class="btn btn-primary mt-4" (click)="scrollToSection('caracteristicas')">
          Descubre Nuestros Servicios
        </button>
      </div>
      <div class="about-image-container fade-in-scroll delay-2">
        <div class="about-image-wrapper">
          <img [src]="heroImagePath" [alt]="hotelName" class="about-image">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Rooms Section -->
<section class="rooms-elegant section" id="habitaciones">
  <!-- Background decorativo -->
  <div class="rooms-bg-pattern"></div>

  <div class="container">
    <!-- Header de sección -->
    <div class="rooms-header fade-in-scroll">
      <div class="rooms-badge">
        <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            fill="currentColor" />
        </svg>
        <span>Comodidad y Elegancia</span>
      </div>
      <h2 class="rooms-title">
        Nuestras <span class="title-highlight">Habitaciones</span>
      </h2>
      <div class="rooms-divider">
        <span class="divider-line"></span>
        <span class="divider-icon">✦</span>
        <span class="divider-line"></span>
      </div>
    </div>

    <!-- Loading State -->
    <div class="rooms-loading" *ngIf="isLoadingRooms">
      <div class="loading-spinner-elegant">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <p class="loading-text">Cargando habitaciones...</p>
    </div>

    <!-- Carousel Container Principal -->
    <div class="carousel-elegant" *ngIf="!isLoadingRooms && rooms.length > 0" (mouseenter)="pauseAutoplay()"
      (mouseleave)="resumeAutoplay()">

      <!-- Navegación lateral izquierda -->
      <button class="carousel-nav carousel-nav-prev" (click)="prevSlide()" [class.hidden]="currentSlide === 0"
        aria-label="Habitación anterior">
        <div class="nav-icon-wrapper">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </button>

      <!-- Contenedor del Carrusel -->
      <div class="carousel-stage">
        <!-- Track del carrusel -->
        <div class="carousel-track-elegant" [style.transform]="getCarouselTransform()"
          (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">

          <!-- Cards de habitaciones -->
          <div class="room-slide" *ngFor="let room of rooms; let i = index" [class.active]="i === currentSlide"
            [class.prev]="i === currentSlide - 1" [class.next]="i === currentSlide + 1" (click)="goToSlide(i)">

            <div class="room-card-elegant">
              <!-- Imagen con overlay -->
              <div class="room-image-wrapper">
                <img [src]="room.image" [alt]="room.name" class="room-img"
                  (error)="room.image = '/Fotos/hotel-andino.jpg'">
                <div class="room-overlay"></div>

                <!-- Badge de precio -->
                <div class="price-tag">
                  <span class="price-amount">{{ room.price }}</span>
                  <span class="price-period">{{ room.period }}</span>
                </div>

                <!-- Indicador de posición -->
                <div class="position-indicator">
                  <span class="current-pos">{{ i + 1 }}</span>
                  <span class="separator">/</span>
                  <span class="total-pos">{{ rooms.length }}</span>
                </div>
              </div>

              <!-- Contenido de la card -->
              <div class="room-info">
                <h3 class="room-title">{{ room.name }}</h3>
                <p class="room-meaning" *ngIf="room.significado">{{ room.significado }}</p>

                <!-- Características -->
                <div class="room-specs">
                  <div class="spec-item">
                    <div class="spec-icon">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" />
                        <path d="M3 9h18M9 9v12" stroke="currentColor" stroke-width="1.5" opacity="0.5" />
                      </svg>
                    </div>
                    <span class="spec-text">{{ room.size }}</span>
                  </div>
                  <div class="spec-item">
                    <div class="spec-icon">
                      <svg viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5" />
                        <path d="M4 20c0-4 4-7 8-7s8 3 8 7" stroke="currentColor" stroke-width="1.5"
                          stroke-linecap="round" />
                      </svg>
                    </div>
                    <span class="spec-text">{{ room.capacity }}</span>
                  </div>
                  <div class="spec-item">
                    <div class="spec-icon">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="10" width="20" height="8" rx="1" stroke="currentColor" stroke-width="1.5" />
                        <path d="M2 18v3M22 18v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M5 10V8a2 2 0 012-2h10a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.5" />
                      </svg>
                    </div>
                    <span class="spec-text">{{ room.bed }}</span>
                  </div>
                </div>

                <!-- Botón de acción -->
                <button class="room-cta" (click)="openRoomDetail(room)">
                  <span>Ver Detalles</span>
                  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Navegación lateral derecha -->
      <button class="carousel-nav carousel-nav-next" (click)="nextSlide()" [class.hidden]="currentSlide >= maxSlide"
        aria-label="Siguiente habitación">
        <div class="nav-icon-wrapper">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
      </button>
    </div>

    <!-- Controles inferiores -->
    <div class="carousel-controls" *ngIf="!isLoadingRooms && rooms.length > 0">
      <!-- Indicadores de progreso -->
      <div class="progress-indicators">
        <button *ngFor="let room of rooms; let i = index" class="progress-dot" [class.active]="i === currentSlide"
          [class.completed]="i < currentSlide" (click)="goToSlide(i)" [attr.aria-label]="'Ir a habitación ' + (i + 1)">
          <span class="dot-fill" [style.animation-duration]="autoplayInterval + 'ms'"
            [class.animating]="i === currentSlide && isAutoplayActive"></span>
        </button>
      </div>

      <!-- Control de autoplay -->
      <button class="autoplay-toggle" (click)="toggleAutoplay()"
        [attr.aria-label]="isAutoplayActive ? 'Pausar' : 'Reproducir'">
        <svg *ngIf="isAutoplayActive" viewBox="0 0 24 24" fill="none" width="20" height="20">
          <rect x="6" y="5" width="4" height="14" rx="1" fill="currentColor" />
          <rect x="14" y="5" width="4" height="14" rx="1" fill="currentColor" />
        </svg>
        <svg *ngIf="!isAutoplayActive" viewBox="0 0 24 24" fill="none" width="20" height="20">
          <path d="M8 5v14l11-7L8 5z" fill="currentColor" />
        </svg>
      </button>
    </div>

    <!-- Empty State -->
    <div class="rooms-empty-elegant" *ngIf="!isLoadingRooms && rooms.length === 0">
      <div class="empty-icon">
        <svg viewBox="0 0 64 64" fill="none" width="64" height="64">
          <rect x="8" y="20" width="48" height="32" rx="4" stroke="currentColor" stroke-width="2" />
          <path d="M8 36h48" stroke="currentColor" stroke-width="2" />
          <path d="M16 20v-8a4 4 0 014-4h24a4 4 0 014 4v8" stroke="currentColor" stroke-width="2" />
          <rect x="20" y="10" width="10" height="10" rx="2" fill="currentColor" opacity="0.2" />
          <rect x="34" y="10" width="10" height="10" rx="2" fill="currentColor" opacity="0.2" />
        </svg>
      </div>
      <h3 class="empty-title">No hay habitaciones disponibles</h3>
      <p class="empty-text">Por favor, contáctenos para más información sobre disponibilidad.</p>
      <a href="#contacto" class="empty-cta">
        <span>Contáctenos</span>
        <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
          <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </a>
    </div>
  </div>
</section>

<!-- Services/Features Section -->
<section class="features-elegant section" id="caracteristicas">
  <div class="container">
    <div class="section-header text-center fade-in-scroll">
      <span class="section-subtitle">Lo Que Ofrecemos</span>
      <h2>Servicios y Comodidades</h2>
      <div class="section-divider"></div>
    </div>

    <div class="features-grid-elegant">
      <div class="feature-card-elegant fade-in-scroll" *ngFor="let feature of features; let i = index"
        [style.animation-delay]="(i * 0.1) + 's'">

        <div class="feature-icon-wrapper-elegant">
          <!-- Vista Andina - Mountain -->
          <svg *ngIf="feature.iconId === 'mountain'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="mountainGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <path d="M8 52L24 20L32 32L44 12L56 52H8Z" stroke="url(#mountainGrad)" stroke-width="2" fill="none" />
            <path d="M24 20L32 32L28 36L20 28L24 20Z" fill="url(#mountainGrad)" opacity="0.2" />
            <path d="M44 12L56 52H36L44 12Z" fill="url(#mountainGrad)" opacity="0.15" />
            <circle cx="52" cy="16" r="6" stroke="url(#mountainGrad)" stroke-width="2" fill="none" />
            <circle cx="52" cy="16" r="3" fill="url(#mountainGrad)" opacity="0.3" />
          </svg>

          <!-- Arte Cultural - Palette -->
          <svg *ngIf="feature.iconId === 'art'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="artGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <path
              d="M32 8C18 8 8 20 8 32C8 44 18 52 28 52C32 52 34 50 34 46C34 44 33 42 33 40C33 36 36 34 40 34C44 34 48 32 52 28C56 24 56 16 48 12C44 10 38 8 32 8Z"
              stroke="url(#artGrad)" stroke-width="2" fill="none" />
            <circle cx="20" cy="28" r="4" fill="url(#artGrad)" opacity="0.6" />
            <circle cx="28" cy="20" r="3" fill="url(#artGrad)" opacity="0.5" />
            <circle cx="40" cy="20" r="3" fill="url(#artGrad)" opacity="0.4" />
            <circle cx="24" cy="40" r="3" fill="url(#artGrad)" opacity="0.7" />
            <path d="M44 28L52 20" stroke="url(#artGrad)" stroke-width="2" stroke-linecap="round" />
          </svg>

          <!-- Gastronomía - Plato con vapor -->
          <svg *ngIf="feature.iconId === 'food'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="foodGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <!-- Plato/Bowl -->
            <path d="M8 36C8 36 8 48 32 48C56 48 56 36 56 36" stroke="url(#foodGrad)" stroke-width="2.5"
              stroke-linecap="round" />
            <ellipse cx="32" cy="36" rx="24" ry="8" stroke="url(#foodGrad)" stroke-width="2" fill="none" />
            <ellipse cx="32" cy="36" rx="18" ry="5" fill="url(#foodGrad)" opacity="0.15" />
            <!-- Base del plato -->
            <path d="M24 52H40" stroke="url(#foodGrad)" stroke-width="2" stroke-linecap="round" />
            <path d="M28 48V52M36 48V52" stroke="url(#foodGrad)" stroke-width="2" />
            <!-- Vapor elegante -->
            <path d="M22 28C22 28 24 24 22 20C20 16 22 12 22 12" stroke="url(#foodGrad)" stroke-width="2"
              stroke-linecap="round" opacity="0.6" />
            <path d="M32 26C32 26 34 22 32 18C30 14 32 10 32 10" stroke="url(#foodGrad)" stroke-width="2"
              stroke-linecap="round" opacity="0.7" />
            <path d="M42 28C42 28 44 24 42 20C40 16 42 12 42 12" stroke="url(#foodGrad)" stroke-width="2"
              stroke-linecap="round" opacity="0.6" />
          </svg>

          <!-- Confort Moderno - Bed -->
          <svg *ngIf="feature.iconId === 'comfort'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="comfortGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <rect x="8" y="28" width="48" height="20" rx="4" stroke="url(#comfortGrad)" stroke-width="2" fill="none" />
            <path d="M8 48V56M56 48V56" stroke="url(#comfortGrad)" stroke-width="2" stroke-linecap="round" />
            <path d="M12 28V24C12 20 16 16 24 16H40C48 16 52 20 52 24V28" stroke="url(#comfortGrad)" stroke-width="2" />
            <rect x="16" y="20" width="12" height="8" rx="2" fill="url(#comfortGrad)" opacity="0.3" />
            <rect x="36" y="20" width="12" height="8" rx="2" fill="url(#comfortGrad)" opacity="0.3" />
            <path d="M8 38H56" stroke="url(#comfortGrad)" stroke-width="1.5" opacity="0.4" />
          </svg>

          <!-- Naturaleza Pura - Leaf -->
          <svg *ngIf="feature.iconId === 'nature'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="natureGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <path d="M32 56C32 56 12 48 12 28C12 12 32 8 32 8C32 8 52 12 52 28C52 48 32 56 32 56Z"
              stroke="url(#natureGrad)" stroke-width="2" fill="none" />
            <path d="M32 56V28" stroke="url(#natureGrad)" stroke-width="2" />
            <path d="M32 36C24 36 20 32 20 28" stroke="url(#natureGrad)" stroke-width="2" stroke-linecap="round" />
            <path d="M32 28C40 28 44 24 44 20" stroke="url(#natureGrad)" stroke-width="2" stroke-linecap="round" />
            <path d="M32 20C28 20 24 18 24 14" stroke="url(#natureGrad)" stroke-width="2" stroke-linecap="round" />
            <circle cx="32" cy="18" r="3" fill="url(#natureGrad)" opacity="0.3" />
          </svg>

          <!-- Atención Familiar - Heart Home -->
          <svg *ngIf="feature.iconId === 'family'" class="feature-icon-svg" viewBox="0 0 64 64" fill="none">
            <defs>
              <linearGradient id="familyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style="stop-color:#C86A4A" />
                <stop offset="100%" style="stop-color:#A47551" />
              </linearGradient>
            </defs>
            <path d="M8 28L32 8L56 28V52C56 54 54 56 52 56H12C10 56 8 54 8 52V28Z" stroke="url(#familyGrad)"
              stroke-width="2" fill="none" />
            <path d="M32 24C28 20 22 20 22 26C22 32 32 40 32 40C32 40 42 32 42 26C42 20 36 20 32 24Z"
              stroke="url(#familyGrad)" stroke-width="2" fill="url(#familyGrad)" fill-opacity="0.2" />
            <path d="M24 56V44C24 42 26 40 28 40H36C38 40 40 42 40 44V56" stroke="url(#familyGrad)" stroke-width="2" />
          </svg>
        </div>

        <h5 class="feature-title-elegant">{{ feature.title }}</h5>
        <p class="feature-description-elegant">{{ feature.description }}</p>

        <div class="feature-decoration"></div>
      </div>
    </div>
  </div>
</section>

<!-- Gallery Section -->
<section class="gallery section bg-light" id="galeria">
  <div class="container">
    <div class="section-header text-center fade-in-scroll">
      <span class="section-subtitle">Nuestros Espacios</span>
      <h2>Galería</h2>
      <div class="section-divider"></div>
      <p class="body-2 section-description">
        Déjate inspirar por la belleza de nuestras instalaciones
      </p>
    </div>

    <div class="gallery-grid-modern">
      <div class="gallery-item-modern fade-in-scroll" *ngFor="let image of galleryImages; let i = index"
        [style.animation-delay]="(i * 0.2) + 's'" (click)="openHotelGallery()">
        <div class="gallery-image-wrapper">
          <img [src]="image.src" [alt]="image.alt" class="gallery-image-modern">
          <div class="gallery-overlay-modern">
            <div class="gallery-overlay-content">
              <h5 class="gallery-title">{{ image.alt }}</h5>
              <button class="btn-view" (click)="openHotelGallery()">
                <span>🖼️</span> Explorar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Experience/Testimonials Section -->
<section class="experience-modern" id="experiencia">
  <div class="experience-bg">
    <div class="experience-gradient"></div>
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
  </div>

  <div class="container">
    <div class="experience-wrapper">
      <!-- Left Content -->
      <div class="experience-text fade-in-scroll">
        <div class="experience-badge">
          <span class="badge-icon">✦</span>
          <span class="badge-text">Tu Experiencia Importa</span>
        </div>
        <h2 class="experience-title fade-in-scroll delay-1">
          Una Experiencia
          <span class="title-highlight">Inolvidable</span>
        </h2>
        <p class="experience-description fade-in-scroll delay-2">
          Más que un hotel, somos tu puerta de entrada a la auténtica experiencia andina.
          Cada momento está diseñado para crear recuerdos que perdurarán toda la vida.
        </p>
        <div class="experience-divider"></div>
      </div>

      <!-- Stats Cards -->
      <div class="stats-container">
        <div class="stat-card stat-card-1 fade-in-scroll delay-3">
          <div class="stat-icon-wrapper">
            <svg class="stat-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <circle cx="12" cy="12" r="4" fill="currentColor" opacity="0.3" />
            </svg>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">100<span class="stat-symbol">%</span></h3>
            <p class="stat-name">Satisfacción</p>
            <span class="stat-bar"></span>
          </div>
        </div>

        <div class="stat-card stat-card-2 fade-in-scroll delay-4">
          <div class="stat-icon-wrapper">
            <svg class="stat-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
              <circle cx="12" cy="12" r="3" fill="currentColor" opacity="0.3" />
              <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <circle cx="12" cy="3" r="1" fill="currentColor" />
              <circle cx="21" cy="12" r="1" fill="currentColor" />
              <circle cx="12" cy="21" r="1" fill="currentColor" />
              <circle cx="3" cy="12" r="1" fill="currentColor" />
            </svg>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">24<span class="stat-symbol">/7</span></h3>
            <p class="stat-name">Atención</p>
            <span class="stat-bar"></span>
          </div>
        </div>

        <div class="stat-card stat-card-3 fade-in-scroll delay-5">
          <div class="stat-icon-wrapper">
            <svg class="stat-icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L14.4 9.2H22L15.8 13.8L18.2 21L12 16.4L5.8 21L8.2 13.8L2 9.2H9.6L12 2Z" fill="currentColor"
                opacity="0.2" />
              <path d="M12 2L14.4 9.2H22L15.8 13.8L18.2 21L12 16.4L5.8 21L8.2 13.8L2 9.2H9.6L12 2Z"
                stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
              <path d="M12 6L13.5 10.5H18L14.25 13.25L15.75 17.75L12 15L8.25 17.75L9.75 13.25L6 10.5H10.5L12 6Z"
                fill="currentColor" opacity="0.4" />
            </svg>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">5<span class="stat-symbol">★</span></h3>
            <p class="stat-name">Calificación</p>
            <span class="stat-bar"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Descubre Sarhua Section -->
<section class="discover-section" id="descubre">
  <div class="container">
    <!-- Header -->
    <div class="section-header text-center fade-in-scroll">
      <span class="section-subtitle">Explora Nuestra Tierra</span>
      <h2>Descubre Sarhua</h2>
      <div class="section-divider"></div>
      <p class="body-2 section-description">
        Un pueblo mágico donde el arte ancestral y la naturaleza andina te esperan
      </p>
    </div>

    <!-- Attractions Grid -->
    <div class="attractions-grid">
      <div class="attraction-card attraction-featured attraction-tablas fade-in-scroll">
        <div class="attraction-image-wrapper tablas-carousel"
             (mouseenter)="stopTablasAutoplay()"
             (mouseleave)="startTablasAutoplay()">
          <!-- Carousel images with crossfade -->
          @for (img of tablasImages; track img.src; let i = $index) {
            <img [src]="img.src"
                 [alt]="img.alt"
                 class="attraction-bg-image"
                 [class.active]="i === currentTablaIndex">
          }
          <!-- Dot indicators -->
          <div class="tablas-dots">
            @for (img of tablasImages; track img.src; let i = $index) {
              <button class="tablas-dot"
                      [class.active]="i === currentTablaIndex"
                      (click)="goToTabla(i)"
                      [attr.aria-label]="'Ver imagen ' + (i + 1)">
              </button>
            }
          </div>
          <div class="attraction-overlay"></div>
          <div class="attraction-content">
            <div class="attraction-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" />
                <path d="M3 9H21M9 21V9" stroke="currentColor" stroke-width="1.5" />
                <circle cx="6" cy="6" r="1" fill="currentColor" />
                <path d="M13 13L15 15L19 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="attraction-title">Tablas de Sarhua</h3>
            <p class="attraction-description body-3">
              Arte ancestral único en el mundo. Pinturas narrativas sobre madera que cuentan historias de la comunidad,
              declaradas Patrimonio Cultural de la Nación.
            </p>
            <span class="attraction-tag">Patrimonio Cultural</span>
          </div>
        </div>
      </div>

      <div class="attraction-card attraction-paisajes fade-in-scroll delay-1">
        <div class="attraction-image-wrapper">
          <img src="/Fotos/paisaje.avif" alt="Paisajes Andinos" class="attraction-bg-image">
          <div class="attraction-overlay"></div>
          <div class="attraction-content">
            <div class="attraction-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 18L9 13L13 17L20 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M2 22H22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <circle cx="18" cy="6" r="2" stroke="currentColor" stroke-width="1.5" />
              </svg>
            </div>
            <h3 class="attraction-title">Paisajes Andinos</h3>
            <p class="attraction-description body-4">
              Montañas majestuosas, cielos estrellados y vistas panorámicas que quitan el aliento.
            </p>
            <span class="attraction-tag">Naturaleza</span>
          </div>
        </div>
      </div>

      <div class="attraction-card attraction-festividades fade-in-scroll delay-2">
        <div class="attraction-image-wrapper tablas-carousel"
             (mouseenter)="stopFestAutoplay()"
             (mouseleave)="startFestAutoplay()">
          @for (img of festImages; track img.src; let i = $index) {
            <img [src]="img.src"
                 [alt]="img.alt"
                 class="attraction-bg-image"
                 [class.active]="i === currentFestIndex">
          }
          <div class="tablas-dots">
            @for (img of festImages; track img.src; let i = $index) {
              <button class="tablas-dot"
                      [class.active]="i === currentFestIndex"
                      (click)="goToFest(i)"
                      [attr.aria-label]="'Ver imagen ' + (i + 1)">
              </button>
            }
          </div>
          <div class="attraction-overlay"></div>
          <div class="attraction-content">
            <div class="attraction-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5" />
                <path d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20" stroke="currentColor"
                  stroke-width="1.5" stroke-linecap="round" />
                <path d="M15 5L17 3M9 5L7 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <h3 class="attraction-title">Festividades</h3>
            <p class="attraction-description body-4">
              Celebraciones vibrantes con danzas, música y tradiciones que perduran por siglos.
            </p>
            <span class="attraction-tag">Cultura Viva</span>
          </div>
        </div>
      </div>

      <div class="attraction-card attraction-gastronomia fade-in-scroll delay-3">
        <div class="attraction-image-wrapper tablas-carousel"
             (mouseenter)="stopGastroAutoplay()"
             (mouseleave)="startGastroAutoplay()">
          <!-- Carousel images with crossfade -->
          @for (img of gastroImages; track img.src; let i = $index) {
            <img [src]="img.src"
                 [alt]="img.alt"
                 class="attraction-bg-image"
                 [class.active]="i === currentGastroIndex">
          }
          <!-- Dot indicators -->
          <div class="tablas-dots">
            @for (img of gastroImages; track img.src; let i = $index) {
              <button class="tablas-dot"
                      [class.active]="i === currentGastroIndex"
                      (click)="goToGastro(i)"
                      [attr.aria-label]="'Ver imagen ' + (i + 1)">
              </button>
            }
          </div>
          <div class="attraction-overlay"></div>
          <div class="attraction-content">
            <div class="attraction-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="12" cy="17" rx="8" ry="4" stroke="currentColor" stroke-width="1.5" />
                <path d="M4 17V12C4 9 7.5 7 12 7C16.5 7 20 9 20 12V17" stroke="currentColor" stroke-width="1.5" />
                <path d="M12 7V4M9 5L12 7L15 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h3 class="attraction-title">Gastronomía</h3>
            <p class="attraction-description body-4">
              Sabores auténticos de la cocina ayacuchana: pachamanca, puca picante y más delicias.
            </p>
            <span class="attraction-tag">Sabor Andino</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Cómo Llegar Section -->
<section class="location-section" id="ubicacion">
  <div class="location-bg"></div>
  <div class="container">
    <div class="location-wrapper">
      <!-- Map Side -->
      <div class="location-map-container fade-in-scroll">
        <div class="location-header-map">
          <span class="location-subtitle">Planifica tu Viaje</span>
          <h3>Cómo Llegar</h3>
          <div class="location-divider"></div>
        </div>
        <div class="map-frame">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d529.5!2d-74.3186943!3d-13.6728736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91125100450b3425%3A0xa03d2483a375affb!2sSUNTUR%20QURI%20WASI!5e1!3m2!1sen!2sus!4v1699999999999!5m2!1sen!2sus"
            width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
        <div class="map-overlay-info">
          <span class="map-badge">
            <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
              <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
                fill="currentColor" />
              <circle cx="12" cy="9" r="2.5" fill="white" />
            </svg>
            Sarhua, Ayacucho
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Modern Footer -->

<!-- Modal for Room Details -->
@if (selectedRoomForModal()) {
  <app-room-detail-modal 
    [room]="selectedRoomForModal()" 
    (closeEvent)="closeRoomDetail()">
  </app-room-detail-modal>
}

<!-- Modal for Hotel Gallery -->
@if (isHotelGalleryOpen()) {
  <app-hotel-gallery-modal
    [images]="hotelGalleryImages()"
    (closeEvent)="closeHotelGallery()">
  </app-hotel-gallery-modal>
}
